module.exports = __webpack_public_path__ + "static/media/level-down.b3be4296.svg";